import { EllipsisForTrans } from '@wix/package-picker-shared-eclipse';
import React from 'react';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import { useTitleEllipsisMaxWidth } from './useTitleEllipsisMaxWidth';

export interface PersonalizedTitleProps {
  titleKey: string;
  params?: Record<string, string>;
}

export const PersonalizedTitle = ({
  titleKey,
  params,
}: PersonalizedTitleProps) => {
  const { t, Trans } = EclipsePackagePickerModule.internals.useTranslations();

  const blankedParams = Object.keys(params ?? {}).reduce<
    Record<string, string>
  >((acc, param) => ({ ...acc, [param]: '' }), {});
  const probeText = t(titleKey, blankedParams).replace(/<[^>]+>/g, '');
  const { maxWidth, probe } = useTitleEllipsisMaxWidth(probeText);

  return (
    <>
      {probe}
      <Trans
        i18nKey={titleKey}
        values={params}
        components={{
          ellipsis: (
            <EllipsisForTrans
              maxWidth={maxWidth}
              position="bottom"
              as="span"
              componentProps={{}}
            />
          ),
        }}
      />
    </>
  );
};
